import { TipoArquivoRef } from '../../tipos/ref';
import { ArquivoSearch } from '../arquivo-search';
import { Usuario } from '../../../usuario/usuario';

export class ArquivoUpload {
    id: number;
    idTipoArquivo: number;
    tipoArquivo: TipoArquivoRef;
    nome: string;
    descricao: string;
    referencia: number;
    idReferenciaPai: number;
    idReferencia: number;
    file: string|any;
    sizeBytes: number;
    extensao: number;

    constructor(referencia: number, idReferenciaPai: number, idReferencia: number) {
        this.id = Math.floor(Math.random() * 1_000); // Random ID
        this.referencia = referencia;
        this.idReferenciaPai = idReferenciaPai;
        this.idReferencia = idReferencia;
    }

    createSearch(usuarioCreated: Usuario): ArquivoSearch {
        const search = new ArquivoSearch();
        search.idUpload = this.id
        search.createdAt = new Date();
        search.idUsuarioCreated = usuarioCreated?.id ?? null;
        search.nomeUsuarioCreated = usuarioCreated?.nome ?? null;
        search.avatarURLUsuarioCreated = usuarioCreated?.avatarUrl ?? null;
        search.idTipoArquivo = this.idTipoArquivo;
        search.url = null;
        search.extensao = this.extensao;
        search.nome = this.nome;
        search.descricao = this.descricao;

        return search;
    }
}
